import AgencyManagementReducer from 'store/agency-management/reducers';

export default AgencyManagementReducer;
